import {Task} from "./Task"

export class Exam {
    private id: string = null;
    private title: string;
    private tasks: Task[];

    constructor(id_?:string, title_?: string) { 
        this.id = id_;
        this.title = title_;
        this.tasks = [];
    }

    public getId(): string {
        return this.id;
    }

    public addTask(task: Task) {
        this.tasks.push(task);
    }

    public removeTask(task: Task) {
        //TODO: implement
    }

    public setTasks(tasks: Task[]) {
        this.tasks = tasks;
    }

    public setTitle(title: string) {
        this.title = title;
    }

    public getTasks(): Task[] {
        return this.tasks;
    }

    public getTitle(): string {
        return this.title;
    }

    public getForSolutionSave(): string {
        var solutions = []
        for (var i = 0; i < this.tasks.length; i++) {
            solutions.push(this.tasks[i].retrieveSolutionJSON());
        }
        var obj = {
            id: this.id,
            solutions: solutions
        }
        return JSON.stringify({solution: obj});
    }

    public getForBackupState(): string {
        var tasks = []
        for (var i = 0; i < this.tasks.length; i++) {
            tasks.push(this.tasks[i].retrieveBackupJSON());
        }
        var obj = {
            id: this.id,
            tasks: tasks,
            title: this.title
        }
        return JSON.stringify({safety: obj});
    }

   
}




// WEBPACK FOOTER //
// ./src/app/lib/Exam.ts